import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations } from "vuex";
import treeMenu from "@/components/treeMenu/index.vue";
import { getListTableUrl } from "@/api/management/user";
import { getRoleList, getMixQueryUserPage } from "@/api/dispose/myfillout";
import { dealRoleType, dealRoleTypeData, stringToArray } from "@/util/utils";
export default {
  name: "selectScope",
  data: function data() {
    var _ref;

    return _ref = {
      selectScopeLoading: false,
      dealRoleType: dealRoleType,
      dealRoleTypeData: dealRoleTypeData,
      stringToArray: stringToArray,
      userName: "",
      treeKey: Date.parse(new Date()),
      handleClickedId: {
        data: 0,
        key: Date.parse(new Date())
      },
      selectUser: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      selectedUserIdArr: [],
      selectedUserListArr: [],
      deptUserData: [],
      chooseAll: false,
      typeData: [{
        id: 1,
        label: "教师"
      }, {
        id: 2,
        label: "教职工"
      }],
      itemName: ["全部", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      sortData: ["默认排序", "升序", "降序"],
      type: 1,
      nameIndexValue: 0,
      nameIndex: null,
      cardActiveId: "",
      page: {
        total: 0,
        // 总页数
        currentPage: 1,
        // 当前页数
        pageSize: 100,
        // 每页显示多少条
        sizes: [10, 20, 50, 100]
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      searchRoleName: "",
      systemRoleData: [],
      defaultExpandIds: [],
      selectUserLoading: false,
      //树形结构
      defaultStaticProps: {
        children: "children",
        label: "name" || "label"
      },
      defaultExpandedKeys: [],
      defaultCheckedArray: [],
      checkedArray: [],
      checkedDeptArray: [],
      checkedId: "",
      checkedName: ""
    }, _defineProperty(_ref, "treeKey", Date.parse(new Date())), _defineProperty(_ref, "currentData", ""), _defineProperty(_ref, "filterText", ""), _ref;
  },
  props: {
    selectScopeData: {
      type: Object,
      required: true
    }
  },
  components: {
    treeMenu: treeMenu
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["checkedItemArray", "chooseDept"])), {}, {
    deptData: function deptData() {
      var deptData = JSON.parse(JSON.stringify(this.chooseDept));
      return deptData;
    }
  }),
  watch: {
    filterText: function filterText(val) {
      this.$refs.deptTree.filter(val);
    },
    deptData: {
      handler: function handler(newVal, oldVal) {
        var _this = this;

        this.$nextTick(function () {
          _this.generateStaticTree(newVal);
        });
      },
      immediate: true,
      deep: true
    },
    "selectScopeData.state": function selectScopeDataState(val) {
      // this.clearCheckedItem();
      this.defaultExpandedKeys = [];

      if (!val) {
        this.defaultDeptIdArr = [];
        this.$refs.deptTree.setCheckedKeys([]);
      } else {
        this.initPageParams();
      }
    },
    checkedItemArray: {
      handler: function handler(newVal, oldVal) {
        this.$nextTick(function () {});
      },
      immediate: true,
      deep: true
    }
  },
  created: function created() {// this.initPageParams();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setDefaultChecked: "setDefaultChecked",
    clearCheckedItem: "clearCheckedItem",
    deleteCheckedItem: "deleteCheckedItem"
  })), {}, {
    filterDeptTree: function filterDeptTree(source, id) {
      var result = "";

      if (source && source.length > 0) {
        var filterFun = function filterFun(target) {
          target.forEach(function (item) {
            if (item.id == id && item.children.length < 1) {
              result = item;
            }

            if (item.children && item.children.length > 0) {
              filterFun(item.children);
            }
          });
        };

        filterFun(source);
      }

      return result;
    },
    clearCheckedArray: function clearCheckedArray() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.defaultDeptIdArr = [];

        _this2.$refs.deptTree.setCheckedKeys([]);
      });
      this.deptUserData.forEach(function (value) {
        _this2.$refs.multipleRoleUserTable.toggleRowSelection(value, false);
      });
      this.checkedArray = [];
    },
    deleteCheckedArray: function deleteCheckedArray(data) {
      var _this3 = this;

      if (Object.keys(data).includes("mans")) {
        var mans = data.mans;
        var index = this.checkedArray.findIndex(function (e) {
          return e.id == data.id;
        });
        var deptIndex = this.checkedDeptArray.findIndex(function (e) {
          return e.id == data.id;
        });
        index > -1 && this.checkedArray.splice(index, 1);
        deptIndex > -1 && this.checkedDeptArray.splice(deptIndex, 1);
        var idArr = this.checkedDeptArray.map(function (item) {
          return item.id;
        });
        this.$nextTick(function () {
          _this3.defaultDeptIdArr = idArr;

          _this3.$refs.deptTree.setCheckedKeys(idArr);

          var userIdArr = mans.map(function (item) {
            return item.userId;
          });

          _this3.deptUserData.forEach(function (item) {
            if (userIdArr.includes(item.userId)) {
              _this3.$nextTick(function () {
                _this3.$refs.multipleRoleUserTable.toggleRowSelection(item, false);
              });
            }
          });
        });
      } else {
        this.checkedArray.forEach(function (item, index) {
          if (item.id == data.deptId) {
            var _mans = item.mans;

            var _index = _mans.findIndex(function (e) {
              return e.userId == data.userId;
            });

            _index > -1 && _mans.splice(_index, 1);

            _this3.deptUserData.forEach(function (item) {
              if (item.userId == data.userId) {
                _this3.$nextTick(function () {
                  _this3.$refs.multipleRoleUserTable.toggleRowSelection(item, false);
                });
              }
            });
          }
        });
      }
    },
    filterDeptRowById: function filterDeptRowById(source, id) {
      var result = "";

      if (source && source.length > 0) {
        var filterFun = function filterFun(target) {
          target.forEach(function (item) {
            if (item.id == id) {
              result = item;
            } else {
              if (item.children && item.children.length > 0) {
                filterFun(item.children);
              }
            }
          });
        };

        filterFun(source);
      }

      return result;
    },
    handleCheckChange: function handleCheckChange(data, checked, indeterminate) {
      var _this4 = this;

      var index = this.checkedArray.findIndex(function (e) {
        return e.id == data.id;
      });
      var deptIndex = this.checkedDeptArray.findIndex(function (e) {
        return e.id == data.id;
      });

      if (checked === true) {
        this.currentDeptId = data.id;
        this.currentData = data;

        if (deptIndex < 0) {
          this.checkedDeptArray.push(data);
        }

        if (this.defaultDeptIdArr[this.defaultDeptIdArr.length - 1] == data.id) {
          this.getMixQueryUserPageData();
        }

        if (!this.defaultDeptIdArr.includes(data.id)) {
          this.getMixQueryUserPageData();
        }

        if (index < 0 && !data.hasChildren) {
          data.mans = [];
          this.checkedArray.push(data);
        } // if (deptIndex < 0) {
        //   let filterArray = [];
        //   filterArray.push(data);
        //   let findParent = targetId => {
        //     let result = this.filterDeptRowById(this.deptData, targetId);
        //     if (result) {
        //       var findIndex = this.checkedDeptArray.findIndex(
        //         e => e.id == result.id
        //       );
        //       if (findIndex < 0) {
        //         filterArray.push(result);
        //       }
        //       if (result.id != 0) {
        //         findParent(result.parentId);
        //       }
        //     }
        //   };
        //   var parentIndex = this.checkedDeptArray.findIndex(
        //     e => e.id == data.parentId
        //   );
        //   if (parentIndex < 0) {
        //     findParent(data.parentId);
        //   }
        //   this.checkedDeptArray = this.checkedDeptArray.concat(
        //     filterArray.reverse()
        //   );
        //   this.$nextTick(() => {
        //     const deptIdArr = this.checkedDeptArray.map(e => {
        //       return e.id;
        //     });
        //     this.$refs.deptTree.setCheckedKeys(deptIdArr);
        //   });
        // }
        // this.$refs.deptTree.setCheckedKeys([data.id]);

      } else {
        index > -1 && this.checkedArray.splice(index, 1);
        deptIndex > -1 && this.checkedDeptArray.splice(deptIndex, 1);

        if (Object.keys(data).includes("mans")) {
          data.mans = [];
          this.$nextTick(function () {
            var userIdArr = [];

            _this4.deptUserData.forEach(function (value) {
              if (userIdArr.includes(value.userId) && value.deptId == data.id) {
                _this4.$refs.multipleRoleUserTable.toggleRowSelection(value, true);
              }

              if (!userIdArr.includes(value.userId) && value.deptId == data.id) {
                _this4.$refs.multipleRoleUserTable.toggleRowSelection(value, false);
              }
            });
          });
        }
      }
    },
    //过滤树形节点
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    generateStaticTree: function generateStaticTree(source) {
      if (source && source.length > 0) {
        var filterFun = function filterFun(target) {
          target.forEach(function (item) {
            var nodeIsLeaf = item.hasChildren ? true : false;
            item.label = item.name;
            item.expandId = item.id;
            item.isLeaf = nodeIsLeaf;
            item.popoverId = "popover" + item.id;
            item.popoverVisible = false;

            if (item.children.length === 0) {
              item.mans = [];
            }

            if (item.children && item.children.length > 0) {
              filterFun(item.children);
            }
          });
        };

        filterFun(source);
      } else {
        return;
      }
    },
    //树形结构部分
    cancelSelected: function cancelSelected() {
      this.selectedUserListArr = [];
      this.selectedUserIdArr = [];
      this.selectedUserArr = [];
      this.getMixQueryUserPageData();
    },
    initData: function initData(data) {
      this.selectedUserIdArr = JSON.parse(JSON.stringify(data.defaultSelected));
      this.selectedUserListArr = JSON.parse(JSON.stringify(data.selectedUserListArr)); // this.$nextTick(()=>{
      // this.getMixQueryUserPageData();//注释
      // })
    },
    initPageParams: function initPageParams() {
      var _this5 = this;

      this.selectedUserIdArr = [];
      this.selectedUserListArr = [];
      this.type = this.typeData[0].id;
      this.nameIndexValue = 0;
      this.nameIndex = null;
      this.cardActiveId = "";
      this.selectUser.current = 1;
      this.treeKey = Date.parse(new Date());
      this.clearCheckedArray();
      this.$nextTick(function () {
        _this5.deptData.forEach(function (item, index) {
          if (item.level == 1 && !_this5.defaultExpandedKeys.includes(item.expandId)) {
            _this5.defaultExpandedKeys.push(item.expandId);
          }
        });

        setTimeout(function () {
          _this5.defaultDeptIdArr = _this5.selectScopeData.depts;

          _this5.$refs.deptTree.setCheckedKeys(_this5.selectScopeData.depts);

          if (_this5.selectScopeData.mans.length > 0) {
            _this5.checkedArray = _this5.selectScopeData.mans;
          }

          if (_this5.selectScopeData.depts.length > 0) {
            var deptArray = [];

            _this5.selectScopeData.depts.forEach(function (item, index) {
              // let result = this.filterDeptTree(this.deptData, item);
              var result = _this5.filterDeptRowById(_this5.deptData, item);

              if (result) {
                deptArray.push(result);
              }
            });

            _this5.checkedDeptArray = deptArray;
            var length = _this5.selectScopeData.depts.length;

            _this5.$refs["deptTree"].setCurrentKey(_this5.selectScopeData.depts.sort(_this5.compare)[length - 1]);

            _this5.getNodeId(_this5.selectScopeData.depts[length - 1]); // this.getMixQueryUserPageData();//注释

          } else {
            _this5.$refs["deptTree"].setCurrentKey(1);

            _this5.getNodeId(1);
          }
        });
      });
    },
    // 数组排序
    compare: function compare(x, y) {
      if (x < y) {
        return -1;
      } else if (x > y) {
        return 1;
      } else {
        return 0;
      }
    },
    userSearch: function userSearch() {
      this.selectUser.current = 1;
      this.getMixQueryUserPageData();
    },
    clearUserName: function clearUserName() {
      this.userName = "";
      this.getMixQueryUserPageData();
    },
    UserCurrentChange: function UserCurrentChange(val) {
      this.selectUser.current = val;
      this.getMixQueryUserPageData();
    },
    selectionChange: function selectionChange(val) {
      this.chooseAll && (this.chooseAll = false);
    },
    allSelectionChange: function allSelectionChange(selection) {
      var _this6 = this;

      if (selection.length > 0) {
        var deptIdArr = this.checkedArray.map(function (e) {
          return e.id;
        });

        if (!deptIdArr.includes(selection[0].deptId)) {
          deptIdArr.push(selection[0].deptId);
          var deptIndex = this.checkedDeptArray.findIndex(function (e) {
            return e.id == selection[0].deptId;
          });

          if (deptIndex < 0) {
            var filterArray = [];
            var data = this.filterDeptRowById(this.deptData, selection[0].deptId);
            filterArray.push(data);

            var findParent = function findParent(targetId) {
              var result = _this6.filterDeptRowById(_this6.deptData, targetId);

              if (result) {
                var findIndex = _this6.checkedDeptArray.findIndex(function (e) {
                  return e.id == result.id;
                });

                if (findIndex < 0) {
                  filterArray.push(result);
                }

                if (result.id != 0) {
                  findParent(result.parentId);
                }
              }
            };

            var parentIndex = this.checkedDeptArray.findIndex(function (e) {
              return e.id == data.parentId;
            });

            if (parentIndex < 0) {
              findParent(data.parentId);
            }

            this.checkedDeptArray = this.checkedDeptArray.concat(filterArray.reverse());
            this.$nextTick(function () {
              // const deptIdArr = this.checkedDeptArray.map(e => {
              _this6.defaultDeptIdArr = _this6.checkedDeptArray.map(function (e) {
                return e.id;
              });

              _this6.$refs.deptTree.setCheckedKeys(_this6.defaultDeptIdArr);
            });
          } // this.defaultDeptIdArr=deptIdArr;
          // this.$refs.deptTree.setCheckedKeys(deptIdArr);


          setTimeout(function () {
            _this6.deptUserData.forEach(function (item) {
              _this6.$nextTick(function () {
                _this6.$refs.multipleRoleUserTable.toggleRowSelection(item, true);

                _this6.checkedArray.forEach(function (value, key) {
                  if (value.id == selection[0].deptId && !value.mans.includes(item)) {
                    value.mans.push(item);
                  }
                });
              });
            });
          }, 100);
        }

        this.checkedArray.forEach(function (item, index) {
          if (Object.keys(item).includes("mans")) {
            if (item.id == selection[0].deptId) {
              var userIdArr = item.mans.map(function (e) {
                return e.userId;
              });
              selection.forEach(function (value, key) {
                if (!userIdArr.includes(value.userId)) {
                  item.mans.push(value);
                }
              });
            }
          }
        });
      } else {
        this.checkedArray.forEach(function (item, index) {
          if (Object.keys(item).includes("mans")) {
            if (item.id == _this6.deptUserData[0].deptId) {
              _this6.deptUserData.forEach(function (value, key) {
                var index = item.mans.findIndex(function (e) {
                  return e.userId == value.userId;
                });
                index > -1 && item.mans.splice(index, 1);
              });
            }
          }
        });
      }
    },
    handleSelect: function handleSelect(selection, row) {
      var _this7 = this;

      this.multipleDeptUser = selection;
      this.chooseAll = false;
      var deptIdArr = this.checkedArray.map(function (e) {
        return e.id;
      });

      if (!deptIdArr.includes(row.deptId) && selection.includes(row)) {
        deptIdArr.push(row.deptId); // this.$refs.deptTree.setCheckedKeys(deptIdArr.reverse());

        var deptIndex = this.checkedDeptArray.findIndex(function (e) {
          return e.id == row.deptId;
        });

        if (deptIndex < 0) {
          var filterArray = [];
          var data = this.filterDeptRowById(this.deptData, row.deptId);
          filterArray.push(data);

          var findParent = function findParent(targetId) {
            var result = _this7.filterDeptRowById(_this7.deptData, targetId);

            if (result) {
              var findIndex = _this7.checkedDeptArray.findIndex(function (e) {
                return e.id == result.id;
              });

              if (findIndex < 0) {
                filterArray.push(result);
              }

              if (result.id != 0) {
                findParent(result.parentId);
              }
            }
          };

          var parentIndex = this.checkedDeptArray.findIndex(function (e) {
            return e.id == data.parentId;
          });

          if (parentIndex < 0) {
            findParent(data.parentId);
          }

          this.checkedDeptArray = this.checkedDeptArray.concat(filterArray.reverse());
          this.$nextTick(function () {
            // const deptIdArr = this.checkedDeptArray.map(e => {
            _this7.defaultDeptIdArr = _this7.checkedDeptArray.map(function (e) {
              return e.id;
            });

            _this7.$refs.deptTree.setCheckedKeys(_this7.defaultDeptIdArr);
          });
        } // this.$refs.deptTree.setCheckedKeys(deptIdArr);


        setTimeout(function () {
          _this7.deptUserData.forEach(function (item) {
            if (item.userId == row.userId) {
              _this7.$nextTick(function () {
                _this7.$refs.multipleRoleUserTable.toggleRowSelection(item, true);

                _this7.checkedArray.forEach(function (item, index) {
                  if (item.id == row.deptId && !item.mans.includes(row)) {
                    item.mans.push(row);
                  }
                });
              });
            }
          });
        }, 100);
      }

      this.checkedArray.forEach(function (item, index) {
        if (Object.keys(item).includes("mans")) {
          if (item.id == row.deptId) {
            // item.mans = selection;
            if (!selection.includes(row)) {
              var _index2 = item.mans.findIndex(function (e) {
                return e.userId == row.userId;
              });

              item.mans.splice(_index2, 1);
            } else {
              if (!item.mans.includes(row)) {
                item.mans.push(row);
              }
            }
          }
        }
      });
      this.$forceUpdate();
      console.log(this.checkedArray);
    },
    handleClick: function handleClick(tab, event) {
      this.type = this.typeData[0].id;
      this.nameIndexValue = 0;
      this.nameIndex = null;
      this.selectUser.current = 1;
    },
    getNodeId: function getNodeId(data) {
      if (Object.prototype.toString.call(data) === "[object Object]") {
        this.currentDeptId = data.id;
      } else {
        this.currentDeptId = data;
      }

      this.selectUser.current = 1;
      this.getMixQueryUserPageData();
    },
    // 设置表格行不可选
    checkSelectable: function checkSelectable(row, index) {
      if (row.isCanChecked) {
        return true;
      }

      return false;
    },
    getMixQueryUserPageData: function getMixQueryUserPageData() {
      var _this8 = this;

      var params = {
        userName: this.userName,
        // queryType: 0,
        current: this.selectUser.current,
        size: this.selectUser.pageSize // userType: this.type,
        // nameIndex: this.nameIndex == "全部" ? "" : this.nameIndex

      }; // if (this.currentData) {
      //   params.deptId = this.currentData.id;
      // }

      if (this.currentDeptId) {
        params.deptId = this.currentDeptId;
      }

      this.selectUserLoading = true;
      getListTableUrl(params).then(function (res) {
        if (res.data.code == 0) {
          _this8.selectUserLoading = false;
          var records = res.data.data.records;

          _this8.$nextTick(function () {
            // this.currentData=this.filterDeptTree(this.deptData,params.deptId);
            _this8.currentData = _this8.filterDeptRowById(_this8.deptData, params.deptId);

            if (records.length > 0 && _this8.currentData) {
              if (!_this8.currentData.hasChildren) {
                records.forEach(function (item) {
                  item.isCanChecked = true;
                });
              } else {
                records.forEach(function (item) {
                  item.isCanChecked = false;
                });
              }
            }
          });

          _this8.deptUserData = records;

          _this8.$nextTick(function () {
            _this8.checkedArray.forEach(function (item, index) {
              if (Object.keys(item).includes("mans")) {
                if (records.length > 0 && item.id == records[0].deptId) {
                  var userIdArr = item.mans.map(function (e) {
                    return e.userId;
                  });

                  _this8.deptUserData.forEach(function (value) {
                    if (userIdArr.includes(value.userId)) {
                      _this8.$refs.multipleRoleUserTable.toggleRowSelection(value, true);
                    } else {
                      _this8.$refs.multipleRoleUserTable.toggleRowSelection(value, false);
                    }
                  });
                }
              }
            });
          });

          _this8.selectUser.total = res.data.data.total;
        }
      });
    },
    typeClick: function typeClick(item) {
      this.type = item.id;
      this.selectUser.current = 1;
      this.getMixQueryUserPageData();
    },
    nameClick: function nameClick(item, int) {
      this.nameIndexValue = int;
      this.nameIndex = item;
      this.selectUser.current = 1;
      this.getMixQueryUserPageData();
    },
    filterFun: function filterFun(source) {
      var _this9 = this;

      source.filter(function (child, index) {
        if (child.expanded) {
          child.expanded = false;
        }

        if (child.childNodes && child.childNodes.length > 0) {
          _this9.filterFun(child.childNodes);
        }
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      if (data.level === 1) {
        this.personType = data.id - 1;
        this.selectedPersonId = "";
        this.cardActiveId = "";
      } else {
        this.personType = data.parentId - 1;
        this.selectedPersonId = data.id;
        this.cardActiveId = data.id;
      }

      this.getMixQueryUserPageData();
    },
    // 删除被选中的用户
    delSelectedUser: function delSelectedUser(row) {
      var _this10 = this;

      var selectIndex = this.selectedUserListArr.findIndex(function (e) {
        return e === row;
      });
      this.selectedUserIdArr.splice(selectIndex, 1);
      this.selectedUserListArr.splice(selectIndex, 1);
      var rowId = row.directorId || row.userId;
      this.deptUserData.forEach(function (item) {
        if (item.userId == rowId) {
          _this10.$refs.multipleRoleUserTable.toggleRowSelection(item, false);
        }
      });
    },
    // 关闭用户选择
    handleDialogClose: function handleDialogClose() {
      // this.$emit("closeSelectScope");
      this.selectScopeData.state = false;
    },
    sureClick: function sureClick(flag, data) {
      var mans = JSON.parse(JSON.stringify(this.checkedArray));
      var depts = JSON.parse(JSON.stringify(this.checkedDeptArray));
      this.$emit("closeSelectScope", {
        depts: depts,
        mans: mans
      });
    }
  })
};